export default "__VITE_ASSET__Dj1ZjY4a__"